"use strict";
angular.module("eventQueuesModalModule", [])
    .controller("eventQueuesModalCtrl", ["$scope", "$rootScope", "$modalInstance", "localStorageService", "$sce","eventQuedata", "trsHttpService", "modalDialog", "$timeout", "$compile", "commandService", "$q", "$validation", "$element",
        function($scope, $rootScope, $modalInstance, localStorageService, $sce,eventQuedata, trsHttpService, modalDialog, $timeout, $compile, commandService, $q, $validation, $element) {
            initStatus();
            initData();

            /**
             * [initData description] 初始化数据
             * @return {[type]} [description]
             */
            function initStatus() {
                $scope.data = {
                    eventQueList:""
                }
                $scope.params={
                    serviceid: 'mlf_publishtask',
                    methodname: 'findPublishTaskById',
                    taskId:eventQuedata.item
                };

            };
            /**
             * [initCreate description] 初始化新建数据
             * @return {[type]} [description]
             */
            function initData(){
                getEventQuenesData();
            }
            function getEventQuenesData(){
                trsHttpService.httpServer(trsHttpService.getWCMRootUrl(), $scope.params, 'post').then(function(data) {
                    $scope.data.eventQueList = data;
                });
            }
            /**
             * [initCreate description] 关闭弹框
             * @return {[type]} [description]
             */
            $scope.close = function() {
                $modalInstance.dismiss();
            };
            /**
             * [initCreate description] 关闭弹框
             * @return {[type]} [description]
             */
            // $scope.confirm = function() {
            //     $modalInstance.close();
            // };
        }]);